import { useDispatch } from 'react-redux';
import { IDiscoverSubMenuProps } from './discover-sub-menu.interfaces';
import Discover from '../../../common/redux/actions/DiscoverActions';
import { SubMenuComponent } from '../sub-menu';
import { messages } from '../../../i18n';
import { useOpenDiscoveriesSelector } from '../../../common/redux/selectors/viz-selector.hook';
import { get, map, noop, values } from 'lodash';
import { useCallback, useMemo } from 'react';
import { ChartSpecs } from '../../ChartSpecs';

export const DiscoverSubMenu = ({
  onToggle = noop,
  hideSidebar,
}: IDiscoverSubMenuProps) => {
  const openDiscoveries = useOpenDiscoveriesSelector();

  const dispatch = useDispatch();

  const setDisplayDiscovery = useCallback(
    id => {
      dispatch(Discover.setDisplayDiscovery(id));
    },
    [dispatch],
  );

  const handleDiscoverSubMenuClick = useCallback(
    id => {
      setDisplayDiscovery(id);
      hideSidebar();
    },
    [hideSidebar, setDisplayDiscovery],
  );

  const menuItems = useMemo(() => {
    const visualizations = map(values(openDiscoveries), 'present.viz').filter(
      Boolean,
    );
    return map(visualizations, ({ id, name, chartType }) => ({
      key: id,
      icon: get(ChartSpecs, chartType)?.icon,
      label: name,
      handleOnItemClick: () => handleDiscoverSubMenuClick(id),
    }));
  }, [handleDiscoverSubMenuClick, openDiscoveries]);

  return (
    <SubMenuComponent
      noBorder={true}
      onToggle={onToggle}
      labels={{
        title: messages.nav.reports,
        more: messages.nav.moreReports,
        less: messages.nav.lessReports,
      }}
      menuItems={menuItems}
    />
  );
};
